import { defineStore } from 'pinia';

export interface ChatStateInterface {
  showChat: boolean;
}

export const useChatStore = defineStore('chat', {
  persist: false,

  state: (): ChatStateInterface => ({
    showChat: false,
  }),

  getters: {
    getShowChat: (state) => state.showChat,
  },

  actions: {
    setShowChat(val: boolean) {
      this.showChat = val;
    },
  },
});
